import React from 'react';
import Translate from "../../../../../../../../components/Translate";
import {setAfkConfigByCompanyId} from "../../../../../../../../services/company/api";
import {isPositiveInteger} from "../../../../../../../../utils/General";
import Input from "../../../../../../../../components-new/form/Input";
import Switch from "../../../../../../../../components-new/form/Switch";
import colors from "../../../../../../../../utils/Colors";
import SettingCard from "../../../../../../../../components-new/ui/SettingCard";

const inputStyle = {width: '100%', border: 'none', height: '38px', background: 'transparent'};

const ChatInactivityAction = ({client, afkConfig, setAfkConfig, isFetching}) => {
    const handleEnabledCheckboxChange = (event) => {
        setAfkConfig({...afkConfig, enabled: event});
        afkConfig.enabled = event;
        setAfkConfigByCompanyId(client.id, {...afkConfig, enabled: event});
    };

    const handleAfkTimeInputChange = (newValue) => {
        setAfkConfig({...afkConfig, afkTime: newValue});
        afkConfig.afkTime = newValue;
    }

    const handleAfkTimeInputBlur = (newValue) => {
        setAfkConfigByCompanyId(client.id, {...afkConfig, afkTime: newValue});
    }

    const validate = (value) => {
        isPositiveInteger(value);
        const parsedValue = Number(value);
        if (parsedValue < 1 || parsedValue > 60) {
            throw new Error('Wrong Range');
        }
    };

    const locked = !afkConfig.enabled || isFetching;

    return (
        <SettingCard
            titleKey="afkConfigs"
            hintKey="afkTimeDescription"
            toggle={
                <Switch
                    checked={afkConfig.enabled}
                    onChange={handleEnabledCheckboxChange}
                    style={{color: colors.silverBlue}}
                />
            }
        >
            <div className={'setting-body setting-body--compact'
                + (!afkConfig.enabled ? ' setting-body--off' : '')}>
                <div className="setting-number">
                    <div className="setting-number__box">
                        <Input
                            type={'number'}
                            style={inputStyle}
                            value={afkConfig.afkTime}
                            validate={validate}
                            onChange={(e) => handleAfkTimeInputChange(e.target.value)}
                            onBlur={(e) => handleAfkTimeInputBlur(e.target.value)}
                            disabled={locked}
                        />
                    </div>
                    <span className="setting-number__unit"><Translate text={'min'}/></span>
                </div>
            </div>
        </SettingCard>
    );
};

export default ChatInactivityAction;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/components/ChatInactivityAction.jsx